"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[908],{

/***/ 908:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ overlay)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function overlay({ wrapper }) {
  const { classes } = window.config

  ;(function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('overlay:show', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass(classes.active)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('overlay:hide', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass(classes.active)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass(classes.active)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', function (evt) {
      if (evt.key === 'Escape') {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')
      }
    })
  })()
}


/***/ })

}]);